import React, { useState, useEffect } from "react";
import CustomSelect from "../utils/CustomSelect";

const AddPopup = ({ showPopup, handleChange, handleClosePopup, handleAddItem, type, fields, formData, intervenantsList = [] }) => {
    const [isFormValid, setIsFormValid] = useState(false);
    const [errors, setErrors] = useState({});

    const mode = type === "Intervenantlink" ? "link" : "add";

    const handleSelectChange = (name, selectedOption) => {
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (selectedOption && selectedOption !== "Choisissez une option") {
                delete newErrors[name];
            }
            return newErrors;
        });

        // console.log(name, selectedOption);

        handleChange({ target: { name, value: selectedOption } });

        // console.log(formData);
    };


    const handleChangeWithValidation = (e) => {
        const { name, value } = e.target;

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value.trim() !== "") {
                delete newErrors[name];
            }
            return newErrors;
        });

        handleChange(e);
    };


    const handleSubmit = () => {
        const formErrors = {};

        if (mode === "link") {
            if (!formData.UUID_ || formData.UUID_ === "") {
                formErrors.UUID_ = "Veuillez sélectionner un intervenant";
            }
        } else {
            fields.forEach((field) => {
                const fieldValue = formData[field.name] || "";

                if (field.required && fieldValue.trim() === "" && field) {
                    formErrors[field.name] = "Veuillez remplir ce champ";
                }

                if (field.required && field.type === "select" && (fieldValue === "" || fieldValue === "Choisissez une option")) {
                    formErrors[field.name] = "Veuillez sélectionner une option";
                }
            });
        }

        if (Object.keys(formErrors).length === 0) {
            handleAddItem();
        } else {
            setErrors(formErrors);
        }
    };


    if (!showPopup) return null;

    const getGroupedFields = () => {
        const sortedFields = [...fields].sort((a, b) => (b.required ? 1 : 0) - (a.required ? 1 : 0));

        let groupedFields = [];
        for (let i = 0; i < sortedFields.length; i += 2) {
            groupedFields.push(sortedFields.slice(i, i + 2));
        }
        return groupedFields;
    };

    // console.log(intervenantsList.map((i) => (i.Nom)))


    return (
        <div
            className="z-10 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50"
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    handleClosePopup();
                }
            }}
        >
            <div className="z-10 absolute bg-white p-8 rounded-xl w-full sm:max-w-3xl max-h-[90vh] overflow-y-auto transition-all duration-300">
                <div className="text-center">
                    <h2 className="mt-5 font-bold text-gray-900 text-3xl">{`Ajout d'un Intervenant`}</h2>
                    <p className="mt-2 text-gray-400 text-sm">
                        Entrez les informations pour ajouter un Intervenant
                    </p>
                </div>
                <div className="space-y-4 mt-8">
                    {mode === "link" ? (
                        <div className="space-y-2">
                            <label className="font-semibold text-gray-500 text-sm tracking-wide">
                                Sélectionnez un intervenant pour l'ajoutez à la déclaration
                                {errors.UUID_ && (
                                    <span className="ml-4 text-red-500 text-xs">{errors.UUID_}</span>
                                )}
                            </label>

                            <CustomSelect
                                options={intervenantsList.map((i) => i.Nom)}
                                value={formData.Nom || "Sélectionnez un intervenant"}
                                onChange={(nom) => {
                                    const selected = intervenantsList.find((i) => i.Nom === nom);
                                    if (selected) {
                                        handleChange({ target: { name: "UUID_", value: selected.UUID_ } });
                                        handleChange({ target: { name: "Nom", value: selected.Nom } });
                                    }
                                }}
                                className={errors.UUID_ ? "border-red-400" : ""}
                            />
                        </div>
                    ) : (
                        getGroupedFields().map((group, index) => (
                            <div key={index} className="flex justify-between gap-4">
                                {group.map((field) => (
                                    <div key={field.name} className="space-y-2 w-full">
                                        <label className="font-semibold text-gray-500 text-sm tracking-wide">
                                            {field.label}
                                            {field.required && <span className="ml-1 text-red-500">*</span>}
                                            {errors[field.name] && (
                                                <span className="ml-4 text-red-500 text-xs">{errors[field.name]}</span>
                                            )}
                                        </label>

                                        {field.type === "select" ? (
                                            <CustomSelect
                                                options={field.options}
                                                value={formData[field.name] || 'Choisissez une option'}
                                                onChange={handleSelectChange.bind(null, field.name)}
                                                className={errors[field.name] ? "border-red-400" : ""}
                                            />
                                        ) : (
                                            <input
                                                type={field.type}
                                                name={field.name}
                                                value={formData[field.name] || ''}
                                                onChange={handleChangeWithValidation}
                                                className={`p-3 border rounded-lg w-full ${errors[field.name] ? "border-red-500" : ""}`}
                                                placeholder={field.placeholder}
                                                required={field.required}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))
                    )}
                </div>


                <div className="flex justify-end gap-4 mt-6">
                    <button
                        onClick={handleSubmit}
                        className={`group block relative shadow-lg px-4 py-3 rounded-md w-full overflow-hidden font-medium text-gray-100 transition-all duration-500 ease-in-out bg-gradient-to-r from-orange-400 to-red-500`}
                    >
                        <span className="absolute inset-0 bg-gradient-to-r from-orange-400 to-red-500 transition-transform group-hover:-translate-x-full duration-500 ease-in-out"></span>
                        <span className="absolute inset-0 bg-gradient-to-r from-red-500 to-orange-600 transition-transform translate-x-full group-hover:translate-x-0 duration-500 ease-in-out"></span>
                        <span className="block relative">Ajouter Intervenant</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddPopup;
